<template>
  <div class="homepage-sport-modules justify-between">
      <LiveEvents/>
      <PreEvents v-if="!isMobile"/>
  </div>
</template>
<script>
  import PreEvents from './PreEvents';
  import LiveEvents from './LiveEvents';
  export default{
    data(){
      return{

      }
    },
    components:{
      PreEvents,
      LiveEvents
    }
  }
</script>